import keys from 'lodash/keys';
import difference from 'lodash/difference';
import findIndex from 'lodash/findIndex';
import {
  getKeysFromSample,
  getSampleDataFromJson,
  checkIfGeo,
  checkIfObject,
  checkIfKeysNested,
  checkIfEmpty,
} from 'modules/catalogFieldTypes/helpers';

/**
 * getNewFieldsFromJson
 * helper function that returns the new fields from the json entry
 */
export const getNewFieldsFromJson = (value, definedFields) => {
  const definedKeys = keys(definedFields);
  let jsonKeys;
  try {
    const jsonVal = JSON.parse(value);
    jsonKeys = getKeysFromSample({ sample: jsonVal, definedFields });
  } catch (err) {
    jsonKeys = [];
  }

  // TODO it might be necessary to also get undefined keys from store as this will always have top-level objects be considered "defined"
  return difference(jsonKeys, definedKeys);
};

/**
 * checkIfNestedObject
 * helper function that verifies whether the object is nested
 */
export const checkIfNestedObject = (newJsonFields, jsonString) => {
  const newRows = getSampleDataFromJson({ newFields: newJsonFields, tableValue: jsonString });
  return (
    findIndex(
      newRows,
      (row) =>
        checkIfKeysNested(row.fieldName) &&
        checkIfObject(row.sample1) &&
        !checkIfGeo(row.sample1) &&
        !checkIfEmpty(row.sample1),
    ) > -1
  );
};

/**
 * isSubmitDisabled
 * helper function that verifies whether the submit button should be disabled
 */
export const isSubmitDisabled = (isSubmitting, tableKey) => {
  const keyExists = tableKey && tableKey.length > 0;
  return isSubmitting || !keyExists;
};
